"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectTypOdmitnuti = void 0;
var formik_1 = require("formik");
var ramda_1 = require("ramda");
var react_1 = __importStar(require("react"));
var hooks_1 = require("../../../hooks");
var components_1 = require("../components");
var Label_1 = __importDefault(require("../components/Label"));
var Dropdown_1 = __importDefault(require("../inputs/Dropdown"));
var mapToOptions = ramda_1.map(function (typ) { return ({ value: typ.id, label: typ.nazev }); });
var SelectTypOdmitnuti = function (_a) {
    var name = _a.name, filterResult = _a.filterResult, defaultSelect = _a.defaultSelect, enableReset = _a.enableReset, inputId = _a.inputId;
    var _b = formik_1.useField(name), field = _b[0], meta = _b[1], helpers = _b[2];
    var _c = hooks_1.useCiselnik('typyOdmitnuti'), data = _c.data, loading = _c.loading, error = _c.error;
    var _d = react_1.useState(), defaultOption = _d[0], setDefaultOption = _d[1];
    react_1.useEffect(function () {
        if (defaultSelect) {
            if (defaultSelect.value) {
                var odmitnuti = data === null || data === void 0 ? void 0 : data.filter(function (d) { return d.id === defaultSelect.value; });
                if ((odmitnuti === null || odmitnuti === void 0 ? void 0 : odmitnuti.length) === 1)
                    setDefaultOption({ selected: odmitnuti[0].id, option: { value: odmitnuti[0].id, label: odmitnuti[0].nazev } });
            }
            helpers.setValue(defaultSelect.value);
        }
    }, [defaultSelect === null || defaultSelect === void 0 ? void 0 : defaultSelect.value]);
    if (error) {
        return react_1.default.createElement(react_1.default.Fragment, null, error);
    }
    if (loading) {
        return react_1.default.createElement(react_1.default.Fragment, null, "na\u010D\u00EDt\u00E1n\u00ED");
    }
    var typy = filterResult ? (data || []).filter(filterResult) : data || [];
    return (react_1.default.createElement(Dropdown_1.default, { hasError: !!meta.error, placeholder: "Vyberte ze seznamu", name: "idTypOdmitnuti", value: field.value, onChange: function (v) { return helpers.setValue(v); }, loadOptions: function () { return Promise.resolve(mapToOptions(typy)); }, defaultOption: defaultOption, enableReset: enableReset, inputId: inputId }));
};
exports.SelectTypOdmitnuti = SelectTypOdmitnuti;
exports.SelectTypOdmitnuti.defaultProps = {
    filterResult: undefined,
    defaultSelect: undefined,
    enableReset: undefined,
    inputId: undefined,
};
exports.default = (function (_a) {
    var label = _a.label, inputId = _a.inputId, props = __rest(_a, ["label", "inputId"]);
    return (react_1.default.createElement(components_1.Field, null,
        react_1.default.createElement(Label_1.default, { htmlFor: inputId }, label),
        react_1.default.createElement(exports.SelectTypOdmitnuti, __assign({}, props, { inputId: inputId }))));
});
